import { z } from 'zod'

import type {
  LoggerActivationId,
  LoggerId,
  OrderId,
  OrderLineItemId,
  ServiceItem,
} from '../../index.js'
import { orderLineItemId } from '../../index.js'

export type BulkCreateServiceItems = {
  orderLineItemId: OrderLineItemId
  orderId: OrderId
  numberOfItems: number
  duration: number
  itemCode: string
  amount: number
}

export type AvailableServiceItem = Pick<
  ServiceItem,
  | 'id'
  | 'amount'
  | 'startedAt'
  | 'expiredAt'
  | 'daysPurchased'
  | 'daysConsumed'
  | 'organizationId'
  | 'projectId'
  | 'orderLineItemId'
> & {
  organizationName: string | null
  projectName: string | null
  lineItemName: string | null
  itemCode: string | null
  erpnextSalesOrderId: string | null
  opportunityName: string | null
  loggerActivations?: Array<{
    loggerActivationId: LoggerActivationId
    loggerId: LoggerId
    activatedAt: Date | null
    suspendedAt: Date | null
    loggerSerial: string | null
    activatedByUser: string | null
    daysConsumed?: number | null
  }>
}

export const bulkCreateServiceItems = z.object({
  orderLineItemId: orderLineItemId,
  numberOfItems: z.number().min(1),
  duration: z.number().min(1),
  itemCode: z.string(),
  amount: z.number().min(0),
})

export type ExtendedServiceItem = ServiceItem & {
  orderId: OrderId
  orderStatus: string
  erpnextQuotationId?: string
  erpnextSalesOrderId?: string
  opportunityName?: string
  lineItemName?: string
  organizationId: number
  organizationName: string
  projectId: number
  projectName: string
  isUsedAsNextServiceItem?: boolean
  // Embedded via kysely's jsonArrayFrom: postgres json_agg serializes
  // timestamps to ISO strings and node-postgres does not revive them, so
  // these arrive as strings rather than Date objects.
  loggerActivations: Array<{
    loggerActivationId: LoggerActivationId
    loggerId: LoggerId
    activatedAt: string | null
    suspendedAt: string | null
    loggerSerial: string | null
    activatedByUser: string | null
    daysConsumed?: number | null
  }>
}
